import { Link } from "react-router-dom";
import { Home, ArrowLeft, Utensils } from "lucide-react";
import { LOGO_URL, BUSINESS } from "../lib/data";
import { ScriptKicker, FilipinoSun } from "../components/Reveal";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[80vh] bg-background relative overflow-hidden flex items-center">
      <div className="absolute top-10 right-10 text-accent/25 hidden md:block"><FilipinoSun size={160} /></div>
      <div className="absolute bottom-10 left-10 text-secondary/20 rotate-12 hidden md:block"><FilipinoSun size={120} /></div>

      <div className="container-eds relative py-20 text-center max-w-3xl mx-auto">
        <img src={LOGO_URL} alt="Ateng K Sarap" className="w-24 h-24 mx-auto object-contain" />
        <div className="mt-6 font-display text-[140px] md:text-[200px] leading-none font-medium text-primary tracking-tight">
          4<span className="italic text-secondary">0</span>4
        </div>
        <ScriptKicker className="block !text-3xl md:!text-4xl mt-2">Aba! Nawala ka.</ScriptKicker>
        <h1 className="mt-3 font-display text-3xl md:text-5xl font-medium text-foreground leading-tight">
          This page took a{" "}
          <span className="italic text-secondary">merienda break</span>.
        </h1>
        <p className="mt-5 text-muted-foreground text-base md:text-lg max-w-xl mx-auto">
          Looks like the page you were looking for isn't on the menu. But
          don't worry — the kitchen is still open and the pansit is ready.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/" data-testid="notfound-home-btn" className="btn-secondary">
            <Home className="w-4 h-4" /> Back to Home
          </Link>
          <Link to="/menu" data-testid="notfound-menu-btn" className="btn-outline">
            <Utensils className="w-4 h-4" /> View Our Menu
          </Link>
        </div>

        <div className="mt-14 pt-10 border-t border-border max-w-md mx-auto">
          <div className="overline">Need to reach us?</div>
          <div className="mt-3 font-display text-2xl text-primary">
            <a href={BUSINESS.phoneLink} className="hover:text-secondary transition-colors">
              {BUSINESS.phone}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
